import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailComposeFromMenu" */ './lazyIndex')
);

// Lazy components
export const ComposeFromMenu = createLazyComponent(lazyModule, m => m.ComposeFromMenu);

// Non-lazy interfaces
export { default as IComposeFromMenu } from './schema/IComposeFromMenu';
